module.exports = "/build/web/svg/icon-marker.cebd7daf3ae906ce5d01afa6cda7c4cf.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-marker.svg
// module id = 126
// module chunks = 13